const PROBE_TIMEOUT_MS = 8000;

function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
    return new Promise((resolve, reject) => {
        const timer = window.setTimeout(() => {
            reject(new Error('probe timeout'));
        }, ms);
        promise.then(
            (value) => {
                window.clearTimeout(timer);
                resolve(value);
            },
            (err) => {
                window.clearTimeout(timer);
                reject(err);
            }
        );
    });
}

export async function probeDownloadOk(
    downloadFile: (docType: number, lookupId?: number, includeReceipts?: boolean) => Promise<any>,
    docType: number,
    lookupId: number
): Promise<boolean> {
    try {
        const response = await withTimeout(downloadFile(docType, lookupId), PROBE_TIMEOUT_MS);
        const blob: Blob | undefined = response && response.data;
        if (!response || response.status < 200 || response.status >= 300) {
            return false;
        }
        if (!blob || blob.size === 0) {
            return false;
        }
        const type = blob.type || '';
        if (type.startsWith('text/') || type === 'application/json' || type === 'application/problem+json') {
            return false;
        }
        if (blob.size <= 512 && (!type || type === 'application/octet-stream')) {
            const peek = await blob.slice(0, Math.min(blob.size, 256)).text();
            if (/unable to locate file|bad request|not found/i.test(peek.trim())) {
                return false;
            }
        }
        return true;
    } catch {
        return false;
    }
}
